/* eslint-disable eag/match-named-export */
import {MutableRefObject} from 'react';

import {GeneratedPlatformDescription} from '@dms/api/sales';

import {createContext} from 'shared/web';

type GeneratedDescriptionsContextType = {
  generatedPlatformDescriptions: GeneratedPlatformDescription[] | null;
  setGeneratedPlatformDescriptions: (value: GeneratedPlatformDescription[] | null) => void;
  resetGeneratedPlatformDescriptions: () => void;
  // Bridge to the mounted general settings form for saving before preview or platform detail.
  formSubmitRef: MutableRefObject<(() => Promise<boolean>) | null>;
  isDirtyRef: MutableRefObject<boolean>;
};

export const [GeneratedDescriptionsContextProvider, useGeneratedDescriptions] =
  createContext<GeneratedDescriptionsContextType>();
